import { stringLiteral } from '@execonline-inc/decoders';
import { Decoder, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../../Resource/Decoders';
import { formTemplatesDecoder } from '../../../../../../../Resource/FormTemplates/Decoders';
import {
  BulkGroupMemberships,
  BulkGroupMembershipsResource,
  UserGroupMembershipsNewFormPayload,
  UserGroupMembershipsNewFormResource,
} from './Types';

const userGroupMembershipsNewFormPayloadDecoder: Decoder<UserGroupMembershipsNewFormPayload> =
  succeed({}).assign('kind', field('kind', stringLiteral('new')));

export const userGroupMembershipsNewFormResourceDecoder: Decoder<UserGroupMembershipsNewFormResource> =
  resourceDecoder(userGroupMembershipsNewFormPayloadDecoder).assign('templates', ({ links }) =>
    field('templates', formTemplatesDecoder(links)),
  );

const bulkGroupMembershipsDecoder: Decoder<BulkGroupMemberships> = succeed({})
  .assign('attemptedCount', field('attempted_count', number))
  .assign('successCount', field('success_count', number))
  .assign('groupName', field('group_name', string));

export const bulkGroupMembershipsResourceDecoder: Decoder<BulkGroupMembershipsResource> =
  resourceDecoder(bulkGroupMembershipsDecoder);
